export const getCookie = (cname: any) => {
  const name = `${cname }=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

// Parameters: (cookie name, cookie value, number of days after which cookie will expire)
export const setCookie = (cname: any, cvalue: any, exdays: any) => {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = `expires=${ d.toUTCString()}`;
  document.cookie = `${cname }=${ cvalue };${ expires };path=/`;
};

export const COOKIES = {
  CUSTOMER_BROWSER_ID: "customerBrowserId",
  IS_NEW_PA_USER: "isNewPAUser",
  EXTERNAL_ID_SHA: "extIdSha",
};
